export default function () {
}

/**************************************************
 * イベントハンドラ
 *************************************************/
$(function () {
    /**
     * ページタイトル設定
     */
    if ($('h1').text()) {
        document.title = $('h1').text() + ' | ' + $('title').text();
    }

    /**
     * トーストメッセージを表示する
     */
    $('.flash_message').fadeOut(5000);

    /**
     * 入力フォームを同期する
     */
    $('.base_search_cond').keyup(function (event) {
        let $el = $(event.target);
        let target = $el.data('sync-target');
        if (target) {
            $(target).val($el.val());
        }
    });
    $('input[data-sync-slave]').change(function (event) {
        let $el = $(event.target);
        let target = $el.data('sync-slave');
        if (target && $(target).val() == "") {
            $(target).val($el.val());
        }
    });

    /**
     * 複数のプルダウンを連動する
     */
    let selectChildOptions = {};
    $('.select_children').each(function (index, element) {
        let $el = $(element);
        selectChildOptions[$el.attr('id')] = $el.html();
    });
    let selectParent = '.select_parent';
    $(selectParent).change(function () {
        //子要素を取得
        let child_target = $(this).data('target-child');
        let $child = $(child_target);
        let origin = selectChildOptions[$child.attr('id')];

        dependSelectChild($(this), $child, origin);
    });
    $(selectParent).trigger('change');

    /**
     * DatePicker設定
     */
    $('.date').each(function () {
        let $input = $(this).find('input');
        $input.datepicker({
            language: "ja"
        });
    });

    /**
     * パスワード設定
     */
    let isPasswordResetSelecter = '#is_password_reset';
    $(isPasswordResetSelecter).change(function () {
        setPasswordEditing();
    });
    $(isPasswordResetSelecter).trigger('change');

    /**
     * サブミット時にフォームを無効化(二重登録防止)
     */
    $('form').submit(function () {
        if ($(this).prop('target') != '_blank') {
            $('input').prop('readonly', true);
            $('button').prop('disabled', true);
            $('.btn').click(function (e) {
                // 親要素のイベントを発生させない。
                e.stopPropagation();
                return false;
            });
            $('a').click(function () {
                return false;
            });
        }
    })
});

/**************************************************
 * 外部コール
 *************************************************/
/**
 * エンターキー押下時の処理
 * @param target
 */
export function enter(target) {
    if (window.event.keyCode === 13) {
        $(target).submit();
    }
}

export function getAddress(zip, pref, city, add1) {
    let code = $(zip).val();
    new YubinBango.Core(code, function (result) {
        $(pref).val(result.region_id).trigger('change');
        $(city).val(result.locality).trigger('change');
        $(add1).val(result.street).trigger('change');
    });
}

export function getAccessToken() {
    return 'Bearer ' + Cookies.get('access_token');
}

import lang_contract from '../../lang/ja.json';
import lang_dispatch from '../../lang/ja-DISPATCH.json';

export function getLang(key, params) {
    let indexes = key.split('.');
    let industryType = appStore.state.auth.industry_type;
    let temp = lang_contract;
    if (industryType === '02') {
        temp = lang_dispatch;
    }

    indexes.forEach(index => {
        temp = temp[index];
    });

    let message = temp;
    if (params) {
        for (key in params) {
            message = message.replace(':' + key, params[key]);
        }
    }
    return message;
}

export function getAction(url) {
    axios.defaults.headers.common['Authorization'] = getAccessToken();
    return axios.get(url);
}

export function postAction(url, params, option) {
    axios.defaults.headers.common['Authorization'] = getAccessToken();
    return axios.post(url, params, option);
}

export function deleteAction(url) {
    axios.defaults.headers.common['Authorization'] = getAccessToken();
    return axios.delete(url);
}

export function getHour(time) {
    let hour;
    if (!time) {
        return null;
    }
    hour = time.substring(0, 2);

    return hour;
}

export function getMinute(time) {
    let minute;
    if (!time) {
        return null;
    }
    minute = time.substring(3, 5);

    return minute;
}

export function checkDisabled(closing) {
    closing.attr('disabled', 'disabled');
}

/**
 * 情報を表示する
 *
 * @param title
 * @param message
 * @param footer
 * @param width
 * @returns {boolean|Promise<SweetAlertResult>|module:sweetalert2|void|*}
 */
export function showInfoDialog(title, message, footer, width) {
    return Swal.fire({
        title: title,
        html: message,
        type: 'info',
        footer: footer,
        width: width,
        confirmButtonText: 'OK',
        customClass: {
            footer: 'd-flex flex-column text-center'
        }
    });
}

/**
 * 情報を表示する(自動クローズ)
 *
 * @param title
 * @param message
 * @param footer
 * @param width
 * @returns {boolean|Promise<SweetAlertResult>|module:sweetalert2|void|*}
 */
export function showInfoTimerDialog(title, message, footer, width) {
    return Swal.fire({
        title: title,
        html: message,
        type: 'info',
        footer: footer,
        width: width,
        customClass: {
            footer: 'd-flex flex-column text-center'
        },
        timer: 5000,
    });
}

/**
 * エラーを表示する
 *
 * @param title
 * @param message
 * @param footer
 * @param width
 * @returns {boolean|Promise<SweetAlertResult>|module:sweetalert2|void|*}
 */
export function showErrorDialog(title, message, footer, width) {
    return Swal.fire({
        title: title,
        html: message,
        type: 'error',
        footer: footer,
        width: width,
        confirmButtonText: 'OK',
        customClass: {
            footer: 'd-flex flex-column text-center'
        }
    });
}

/**
 * 確認ダイアログを表示する
 *
 * @param title
 * @param message
 * @param footer
 * @param width
 * @returns {boolean|Promise<SweetAlertResult>|module:sweetalert2|void|*}
 */
export function showConfirmationDialog(title, message, footer, width) {
    return Swal.fire({
        title: title,
        html: message,
        type: 'question',
        footer: footer,
        width: width,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        customClass: {
            footer: 'd-flex flex-column text-center'
        }
    });
}

/**
 * アラートを表示する
 *
 * @param title
 * @param message
 * @param footer
 * @param width
 * @returns {boolean|Promise<SweetAlertResult>|module:sweetalert2|void|*}
 */
export function showAlertDialog(title, message, footer, width) {
    return Swal.fire({
        title: title,
        html: message,
        type: 'warning',
        footer: footer,
        width: width,
        confirmButtonText: 'OK',
        customClass: {
            footer: 'd-flex flex-column text-center'
        }
    });
}

/**
 * 金額をフォーマットする
 * @param num
 * @returns {string}
 */
export function number_format(num) {
    return num.toString().replace(
        /(\d+?)(?=(?:\d{3})+$)/g,
        function (x) {
            return x + ',';
        }
    ) + '円';
}

/**************************************************
 * 内部処理
 *************************************************/
/**
 * 多要素に依存するセレクトボックスを同期する
 * @param $parent
 * @param $child
 * @param childOrigin
 */
function dependSelectChild($parent, $child, childOrigin) {
    $child.html(childOrigin);
    let parent_value = $parent.val();

    $child.find('option').each(function () {
        let child_value = $(this).data('parent');

        //親要素が未指定の場合は処理しない
        if (!parent_value) {
            return;
        }

        //親要素の指定がないものは残す
        if (!child_value) {
            return;
        }

        //親要素と異なるものを削除する
        if (+parent_value !== +child_value) {
            $(this).remove();
        }
    });
    $child.trigger('change');

    //親要素が未選択の場合、子要素を非活性化
    if ($child.data('parent-required') === true) {
        if (!parent_value) {
            $child.attr('disabled', 'disabled');
        } else {
            $child.removeAttr('disabled');
        }
    }
}

/**
 * パスワード活性/非活性を制御する
 */
function setPasswordEditing() {
    if ($('#is_password_reset').prop('checked')) {
        $('#password').prop('disabled', false);
        $('#password_confirmation').prop('disabled', false);
    } else {
        $('#password').prop('disabled', true);
        $('#password_confirmation').prop('disabled', true);
    }
}